/**
 * Shared password validation utility.
 * Standardized rules: min 8 chars, uppercase, lowercase, number, special character.
 */

const SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

export const PASSWORD_HELPER_TEXT = 'Mínimo 8 caracteres, con mayúscula, minúscula, número y símbolo';

/**
 * Validates a password against the standard policy.
 * Returns an array of error messages. Empty array means valid.
 */
export function validatePassword(password: string): string[] {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push('La contraseña debe tener al menos 8 caracteres');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('La contraseña debe contener al menos una letra mayúscula');
  }

  if (!/[a-z]/.test(password)) {
    errors.push('La contraseña debe contener al menos una letra minúscula');
  }

  if (!/[0-9]/.test(password)) {
    errors.push('La contraseña debe contener al menos un número');
  }

  if (!SPECIAL_CHAR_REGEX.test(password)) {
    errors.push('La contraseña debe contener al menos un símbolo especial (!@#$%^&*...)');
  }

  return errors;
}
